import { render, staticRenderFns } from "./bacground-config-mobile.vue?vue&type=template&id=7c899e1a&"
import script from "./bacground-config-mobile.vue?vue&type=script&lang=ts&"
export * from "./bacground-config-mobile.vue?vue&type=script&lang=ts&"
import style0 from "./bacground-config-mobile.vue?vue&type=style&index=0&id=7c899e1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports